import { useState, useEffect, useCallback } from 'react';

export default function useWatchLocalStorage(key: string) {
  const [value, setValue] = useState<string | null>(null);
  const getSnapshot = useCallback(() => {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(key);
  }, [key]);

  useEffect(() => {
    setValue(getSnapshot());

    const handleStorageChange = () => {
      setValue(getSnapshot());
    };

    window.addEventListener('storage', (event) => {
      if (event.key === key) {
        setValue(event.newValue);
      }
    });
    window.addEventListener('local-storage-update', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('local-storage-update', handleStorageChange);
    };
  }, [key, getSnapshot]);

  return value;
}